import UserInfoScreen from 'features/lineOfCredit/screens/userInfo/UserInfoScreen';
import React from 'react';

export default function Page() {
  return <UserInfoScreen />;
}
